import React, { FC } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';

import { RoleManagementDialogContent } from '../RoleManagementDialogContent/RoleManagementDialogContent';
import { SSRS } from '../../ssrsPageManagement.classes';
// import { SCUIMenuRoleDialogContent } from "../SCUIMenuRoleDialogContent/SCUIMenuRoleDialogContent";

interface IProps {
    selectedRow?: any;
    open?: boolean;
    onClose?: any;
    roles?: any;
}
export const RoleManagementDialog: FC<IProps> = ({ selectedRow = null, open = false, onClose, roles }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            className={SSRS.roleDialog}
            data-report-id={selectedRow?.reportId}
        >
            <DialogTitle className={SSRS.roleDialogTitle}> {selectedRow && selectedRow.text}</DialogTitle>
            <RoleManagementDialogContent selectedRow={selectedRow} onCloseDialog={onClose} roles={roles} />
        </Dialog>
    );
};
